import { Link, Text } from "@chakra-ui/react";

export const KernelDisclaimer = ({ hasSecretKeyForClaim }: { hasSecretKeyForClaim: boolean }) => {
	return (
		<>
			{hasSecretKeyForClaim ? (
				<Text color="textSecondary" fontSize="14px" lineHeight="20px" fontWeight="400">
					By continuing with Claim $KERNEL, you agree to the{" "}
					<Link
						color="textPrimary"
						fontWeight="600"
						textDecor="underline"
						href="https://docs.google.com/document/d/1SuXHTQVprMGLbfzICaWVENChlDE4BC8c/edit?usp=sharing&ouid=115525391805349315815&rtpof=true&sd=true"
						target="_blank">
						terms and conditions
					</Link>{" "}
					of Kernel Token Airdrop.
				</Text>
			) : (
				<Text color="textSecondary" fontSize="14px" lineHeight="20px" fontWeight="400">
					By continuing with Claim Staked $KERNEL, you agree to the{" "}
					<Link
						color="textPrimary"
						fontWeight="600"
						textDecor="underline"
						href="https://docs.google.com/document/d/1SuXHTQVprMGLbfzICaWVENChlDE4BC8c/edit?usp=sharing&ouid=115525391805349315815&rtpof=true&sd=true"
						target="_blank">
						terms and conditions
					</Link>{" "}
					of Kernel Token Airdrop. <br /> <br />
					Your staked $KERNEL position will be available{" "}
					<Link color="textPrimary" fontWeight="600" textDecor="underline" href="https://kerneldao.com/stake/" target="_blank">
						here
					</Link>
				</Text>
			)}
		</>
	);
};
